type BadgeStatus =
  | 'draft_ready'
  | 'sent'
  | 'replied'
  | 'bounced'
  | 'finding'
  | 'finding_recruiters'
  | 'in_progress'
  | 'drafts_ready'
  | 'completed';

const config: Record<BadgeStatus, { label: string; className: string; style?: React.CSSProperties; pulse?: boolean }> = {
  draft_ready:        { label: 'Draft Ready',           className: 'bg-g-light text-g-text border border-g-border' },
  sent:               { label: 'Sent',                  className: 'bg-g text-white' },
  replied:            { label: 'Replied ✓',             className: 'bg-g text-white' },
  bounced:            { label: 'Bounced',               className: 'bg-red-100 text-red-600' },
  finding:            { label: 'Finding…',              className: 'text-hint animate-pulse-soft', style: { backgroundColor: '#F4F5F1' } },
  finding_recruiters: { label: 'Finding recruiters…',   className: 'text-hint animate-pulse-soft', style: { backgroundColor: '#F4F5F1' } },
  in_progress:        { label: 'In Progress',           className: 'bg-g-light text-g-text border border-g-border' },
  drafts_ready:       { label: 'Drafts Ready',          className: 'bg-g-light text-g-text border border-g-border' },
  completed:          { label: 'Completed',             className: 'bg-g text-white' },
};

export default function StatusBadge({ status }: { status: BadgeStatus | string }) {
  const cfg = config[status as BadgeStatus] ?? { label: status, className: 'text-hint', style: { backgroundColor: '#F4F5F1' } };
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap flex-shrink-0 ${cfg.className}`}
      style={cfg.style}
    >
      {cfg.label}
    </span>
  );
}
